export const type = 'hr';

export const isHorizontalRule = node => node.type === type;
